import React from 'react'
import {BsCheckCircle, BsClock, BsXCircle} from 'react-icons/bs'
import {IoHelp} from 'react-icons/io5'
import _ from "lodash"

export const CourseActionTypes = Object.freeze({
    REGISTER: 'register',
    COURSE_CREATE: 'course-create',
    COURSE_UPDATE: 'course-update',
    COURSE_UPDATE_RESULT_ALL: 'course-update-result-all',
    COURSE_COPY: 'course-copy',
    COURSE_DELETE: 'course-delete',
    ENROLLMENT_CREATE: 'enrollment-create',
    ENROLLMENT_DELETE: 'enrollment-delete',
    ENROLLMENT_REJECT: 'enrollment-reject',
    ENROLLMENT_APPROVE: 'enrollment-approve',
    SHOW_CLASS_LIST_MODAL: 'show-class-list-modal',
    SHOW_SUBJECT_LIST_MODAL: 'show-subject-list-modal',
    SHOW_TEACHER_LIST_MODAL: 'show-teacher-list-modal',
    SHOW_ENROLLMENT_REGISTER_MODAL: 'show-enrollment-modal',
})

export const ClassActionTypes = Object.freeze({
    CLASS_CREATE: 'class-create',
    CLASS_UPDATE: 'class-update',
    CLASS_DELETE: 'class-delete',
    SHOW_SUBJECT_LIST_MODAL: 'show-subject-list-modal',
    SHOW_STUDENT_LIST_MODAL: 'show-student-list-modal',
    SHOW_TEACHER_LIST_MODAL: 'show-teacher-list-modal',
    SHOW_TIMETABLE_LIST_MODAL: 'show-timetable-list-modal',
})

export const StudentActionTypes = Object.freeze({
    STUDENT_CREATE: 'student-create',
    STUDENT_UPDATE: 'student-update',
    STUDENT_DELETE: 'student-delete',
    STUDENT_DETAIL: 'student-detail',
    STUDENT_MOVE: 'student-move',
    STUDENT_REVOKE: 'student-revoke',
    STUDENT_ASSIGN: 'student-assign',
    STUDENT_IN_COURSE_UPDATE: 'student-in-course-update',
    STUDENT_IN_CLASS_UPDATE: 'student-in-class-update',
    STUDENT_ATTENDANCE_TRACKING: 'student-attendance-tracking',
    STUDENT_SUBJECT_SCORE_SUMMARY: 'student-subject-score-summary',
    STUDENT_AWARDING_MEDAL: 'student-awarding-medal',
    STUDENT_REVOKE_MEDAL: 'student-REVOKE-medal',
})

export const TeacherActionTypes = Object.freeze({
    TEACHER_CREATE: 'teacher-create',
    TEACHER_UPDATE: 'teacher-update',
    TEACHER_DELETE: 'teacher-delete',
    TEACHER_READ: 'teacher-read',
})

export const TimetableActionTypes = Object.freeze({
    TIMETABLE_CREATE: 'timetable-create',
    TIMETABLE_UPDATE: 'timetable-update',
    TIMETABLE_DUPLICATE: 'timetable-copy',
    TIMETABLE_DELETE: 'timetable-delete',
    TIMETABLE_READ: 'timetable-read',
})

export const SubjectActionTypes = Object.freeze({
    SUBJECT_CREATE: 'subject-create',
    SUBJECT_UPDATE: 'subject-update',
    SUBJECT_DELETE: 'subject-delete',
    SUBJECT_READ: 'subject-read',
})

export const GradeActionTypes = Object.freeze({
    GRADE_CREATE: 'grade-create',
    GRADE_UPDATE: 'grade-update',
    GRADE_DELETE: 'grade-delete',
    GRADE_DETAIL: 'grade-detail',
    GRADE_HISTORY: 'grade-history',
    COURSE_CLASS_EXAM_UPDATE: 'course-class-exam-update',
    VIEW_BY_SUBJECT_FILTER: 'view-by-subject-filter',
    GRADE_ADD_PARTICIPANT: 'grade-add-participant',
})

export const AttendanceActionTypes = Object.freeze({
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    DETAIL: 'detail',
    VIEW_BY_SUBJECT_FILTER: 'view-by-subject-filter',
})

export const AnnouncementActionTypes = Object.freeze({
    CREATE: 'create',
    UPDATE: 'update',
    DELETE: 'delete',
    DETAIL: 'detail',
})

export const grade_score_types = {
    text: {
        label: 'text',
        value: 'text',
    },
    number: {
        label: 'number',
        value: 'number',
    },
}

export const course_status_options = {
    normal: {
        value: 1,
        label: 'active',
    },
    closed: {
        value: 9,
        label: 'close',
    },
}

export const attendance_status_options = {
    reset: {
        value: 0,
        label: 'undefined',
        className: 'text-color-500',
    },
    absent: {
        value: -2,
        label: 'unexcused absence',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-red-500',
    },
    absent_reason: {
        value: -1,
        label: 'excused absence',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-orange-500',
    },
    present: {
        value: 1,
        label: 'in attendance',
        icon: <IoHelp size={12}/>,
        className: 'font-medium text-green-600',
    },
}

export const enrollment_status_options = {
    pending: {
        value: -1,
        label: 'pending',
        icon: <BsClock size={11}/>,
        className: 'text-blue-500',
    },
    approved: {
        value: 1,
        label: 'approved',
        icon: <BsCheckCircle size={11}/>,
        className: 'text-green-500',
    },
    rejected: {
        value: -2,
        label: 'rejected',
        icon: <BsXCircle size={11}/>,
        className: 'text-red-500',
    },
}

export const getGradeScore = (item, time = 0) => {
    const {score_type} = item ?? {}
    let score_text = null;
    let score_number = null;
    switch (time) {
        case 1:
            score_text = _.get(item, 'score_1_text')
            score_number = _.get(item, 'score_1_number')
            break;
        case 2:
            score_text = _.get(item, 'score_2_text')
            score_number = _.get(item, 'score_2_number')
            break;
        default:
            score_text = _.get(item, 'score_text')
            score_number = _.get(item, 'score_number')
            break;
    }
    switch (score_type) {
        case grade_score_types.text.value:
            return score_text
        case grade_score_types.number.value:
            return score_number
        default:
            break
    }

    return null;
}
